/* DOUBLIX — theme.js */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};

  /* ---------- Money ---------- */

  function formatMoney(cents) {
    var fmt = (window.theme.shop && window.theme.shop.moneyFormat) || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    // Shopify money_format placeholders; handle the common amount variants.
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }
  window.theme.formatMoney = formatMoney;

  /* ---------- Scroll reveal ---------- */

  function initReveal() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var enabled = window.theme.settings && window.theme.settings.animations;
    var els = document.querySelectorAll('.reveal');

    if (reduce || !enabled || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Verrou de scroll ----------
     `body { overflow: hidden }` ne suffit pas : sur iOS la page continue de défiler
     derrière l'overlay, et le contenu peut sauter. On fige le body en position: fixed
     à son offset courant, puis on restaure le scroll exact à la fermeture.
     Compteur partagé pour que le tiroir panier et le menu ne se déverrouillent pas
     l'un l'autre s'ils venaient à se superposer. */

  var ScrollLock = {
    count: 0,
    y: 0,

    lock: function () {
      if (this.count === 0) {
        this.y = window.scrollY || window.pageYOffset || 0;
        var b = document.body.style;
        b.position = 'fixed';
        b.top = -this.y + 'px';
        b.left = '0';
        b.right = '0';
        b.width = '100%';
      }
      this.count++;
    },

    unlock: function () {
      this.count = Math.max(0, this.count - 1);
      if (this.count > 0) return;
      var b = document.body.style;
      b.position = '';
      b.top = '';
      b.left = '';
      b.right = '';
      b.width = '';
      window.scrollTo(0, this.y);
    }
  };

  /* ---------- Focus trap ---------- */

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(container, e) {
    var items = Array.prototype.filter.call(
      container.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  /* ---------- Cart drawer ---------- */

  var CartDrawer = {
    el: null,
    lastFocus: null,

    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;

      var self = this;

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener) {
          // Si le tiroir a échoué à charger, on laisse le lien natif emmener vers /cart
          // (échappatoire garantie) au lieu de rouvrir un tiroir en erreur.
          if (self.loadFailed && opener.tagName === 'A') { return; }
          e.preventDefault(); self.open(); return;
        }
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); }
      });

      document.addEventListener('keydown', function (e) {
        if (!self.el.hasAttribute('open')) return;
        if (e.key === 'Escape') { self.close(); }
        if (e.key === 'Tab') { trapFocus(self.el, e); }
      });

      // Quantity / remove inside the drawer
      this.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-retry]')) { e.preventDefault(); self.refresh(); return; }
        var btn = e.target.closest('[data-qty]');
        if (!btn) return;
        e.preventDefault();
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        self.change(line, qty);
      });

      // Add-ons (ajout/retrait + gravure du socle)
      this.el.addEventListener('click', function (e) {
        var card = e.target.closest('[data-addon-card]');
        if (!card) return;
        if (e.target.closest('[data-engrave-confirm]')) { e.preventDefault(); self.confirmEngrave(card); return; }
        if (e.target.closest('[data-engrave-cancel]')) { e.preventDefault(); self.closeEngrave(card); return; }
        if (e.target.closest('[data-addon-toggle]')) { e.preventDefault(); self.toggleAddon(card); }
      });
      this.el.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var input = e.target.closest('[data-engrave-input]');
        if (!input) return;
        e.preventDefault();
        var card = input.closest('[data-addon-card]');
        if (card) self.confirmEngrave(card);
      });
    },

    open: function () {
      this.lastFocus = document.activeElement;
      this.el.setAttribute('open', '');
      document.body.classList.add('cart-open');
      ScrollLock.lock();
      this.refresh();
      // Cibler le bouton, pas le scrim : `[data-cart-close]` matche d'abord le <div> du fond,
      // qui n'est pas focusable — le focus serait perdu pour le clavier et les lecteurs d'écran.
      var close = this.el.querySelector('button[data-cart-close]');
      if (close) close.focus();
    },

    // Ouvre le tiroir IMMÉDIATEMENT avec un spinner (pendant l'ajout des figurines), sans
    // fetch : le client voit une réaction instantanée au lieu d'un bouton figé. On appelle
    // refresh() ensuite, une fois les lignes ajoutées.
    openAdding: function (msg) {
      this.lastFocus = document.activeElement;
      this.el.setAttribute('open', '');
      document.body.classList.add('cart-open');
      ScrollLock.lock();
      var body = this.el.querySelector('[data-cart-body]');
      var empty = this.el.querySelector('[data-cart-empty]');
      var footer = this.el.querySelector('[data-cart-footer]');
      var addons = this.el.querySelector('[data-cart-addons]');
      if (empty) empty.hidden = true;
      if (footer) footer.hidden = true;
      if (addons) addons.hidden = true;
      if (body) {
        body.hidden = false;
        body.innerHTML = '<li class="cd__loading"><span class="cd__spinner" aria-hidden="true"></span>' +
          escapeHtml(msg || strings.cartAdding || 'Ajout en cours…') + '</li>';
      }
      var close = this.el.querySelector('button[data-cart-close]');
      if (close) close.focus();
    },

    close: function () {
      if (!this.el.hasAttribute('open')) return;
      this.el.removeAttribute('open');
      document.body.classList.remove('cart-open');
      ScrollLock.unlock();
      if (this.lastFocus) this.lastFocus.focus();
    },

    change: function (line, quantity) {
      var self = this;
      self.el.classList.add('is-loading');
      fetch(routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('change ' + r.status);
          return r.json();
        })
        .then(function (cart) { self.render(cart); })
        .catch(function () { self.fallback(); });
    },

    refresh: function () {
      var self = this;
      var body = this.el.querySelector('[data-cart-body]');
      var empty = this.el.querySelector('[data-cart-empty]');
      var footer = this.el.querySelector('[data-cart-footer]');
      var addons = this.el.querySelector('[data-cart-addons]');

      // Indicateur de chargement pendant les tentatives (au lieu d'un écran vide/erreur).
      if (body) {
        if (empty) empty.hidden = true;
        if (footer) footer.hidden = true;
        if (addons) addons.hidden = true;
        body.hidden = false;
        body.innerHTML = '<li class="cd__loading"><span class="cd__spinner" aria-hidden="true"></span>' +
          escapeHtml(strings.cartLoading || 'Chargement de ton panier…') + '</li>';
      }

      // On charge le panier et on l'affiche dans le tiroir. UNE seule nouvelle tentative, après
      // une pause franche, si Shopify renvoie un 429 (Too Many Requests) passager. On limite
      // volontairement à 2 requêtes : réessayer en rafale AGGRAVE un 429 (fenêtre glissante).
      // On ne redirige JAMAIS vers /cart ; sinon, message en ligne + bouton Réessayer manuel.
      var delays = [0, 2500];
      function attempt(i) {
        return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('cart ' + r.status);
            return r.json();
          })
          .then(function (cart) { self.render(cart); })
          .catch(function () {
            if (i + 1 < delays.length) {
              return new Promise(function (res) { setTimeout(res, delays[i + 1]); }).then(function () { return attempt(i + 1); });
            }
            self.fallback();
          });
      }
      attempt(0);
    },

    fallback: function () {
      this.loadFailed = true;
      // Échec de chargement du panier (429 sur thème en aperçu, réseau…) : on emmène
      // AUTOMATIQUEMENT le client sur /cart, qui fonctionne (navigation top-level, non
      // soumise au filtrage anti-bot des requêtes fetch). Il n'est jamais bloqué.
      if (routes.cart_url) {
        window.location.assign(routes.cart_url);
        return;
      }
      // Cas extrême sans route panier : message minimal, sans redirection possible.
      this.el.classList.remove('is-loading');
      var body = this.el.querySelector('[data-cart-body]');
      if (body) {
        body.innerHTML = '<li class="cd__error"><p>' +
          escapeHtml(strings.cartError || 'Impossible de charger le panier.') + '</p></li>';
      }
    },

    render: function (cart) {
      this.el.classList.remove('is-loading');
      this.loadFailed = false;
      updateCartCount(cart.item_count);
      this.updateAddons(cart);

      var body = this.el.querySelector('[data-cart-body]');
      var footer = this.el.querySelector('[data-cart-footer]');
      var empty = this.el.querySelector('[data-cart-empty]');
      if (!body) return;

      if (!cart.item_count) {
        body.innerHTML = '';
        if (empty) empty.hidden = false;
        if (footer) footer.hidden = true;
        return;
      }

      if (empty) empty.hidden = true;
      if (footer) footer.hidden = false;

      body.innerHTML = cart.items.map(function (item, i) {
        // Vignettes 72x72 rendues seulement à l'ouverture du tiroir : toujours visibles,
        // donc eager. En lazy, un <img> révélé par un transform peut ne jamais être chargé.
        var img = item.image
          ? '<img src="' + thumbUrl(item.image) + '" alt="" width="72" height="72" loading="eager">'
          : '<div class="cart-item__ph" aria-hidden="true"></div>';

        var props = '';
        if (item.properties) {
          props = Object.keys(item.properties)
            .filter(function (k) { return k.charAt(0) !== '_' && item.properties[k]; })
            .map(function (k) {
              var val = String(item.properties[k]);
              var isImg = /\.(jpe?g|png|gif|webp|heic|heif)(\?|$)/i.test(val) || val.indexOf('/uploads/') !== -1;
              if (isImg) {
                // Photo cliente : miniature + libellé plutôt qu'une longue URL.
                return '<span class="cart-item__prop cart-item__prop--photo">' +
                  '<img src="' + escapeAttr(val) + '" alt="" width="26" height="26" loading="lazy">' +
                  escapeHtml(k) +
                '</span>';
              }
              return '<span class="cart-item__prop">' + escapeHtml(k) + ': ' + escapeHtml(val) + '</span>';
            })
            .join('');
        }

        return (
          '<li class="cart-item">' +
            '<a class="cart-item__media" href="' + item.url + '">' + img + '</a>' +
            '<div class="cart-item__info">' +
              '<a class="cart-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
              (item.variant_title ? '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
              props +
              '<div class="cart-item__row">' +
                '<div class="qty">' +
                  '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="' + escapeAttr(strings.decrease || 'Diminuer') + '">&minus;</button>' +
                  '<span aria-live="polite">' + item.quantity + '</span>' +
                  '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="' + escapeAttr(strings.increase || 'Augmenter') + '">+</button>' +
                '</div>' +
                '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
            '<button class="cart-item__remove" type="button" data-line="' + (i + 1) + '" data-qty="0" aria-label="' + escapeAttr(strings.remove || 'Retirer') + '">&times;</button>' +
          '</li>'
        );
      }).join('');

      var subtotal = this.el.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      // Économies (remises automatiques : packs 2/3 figurines) — comme sur la page panier.
      var savingsEl = this.el.querySelector('[data-cart-savings]');
      if (savingsEl) {
        var apps = cart.cart_level_discount_applications || [];
        if (apps.length) {
          savingsEl.innerHTML = apps.map(function (a) {
            return '<li class="cd__saving">' + escapeHtml(a.title) +
              '<span>&minus;' + formatMoney(a.total_allocated_amount) + '</span></li>';
          }).join('');
          savingsEl.hidden = false;
        } else if (cart.total_discount > 0) {
          savingsEl.innerHTML = '<li class="cd__saving">' +
            escapeHtml(strings.savings || 'Économie') +
            '<span>&minus;' + formatMoney(cart.total_discount) + '</span></li>';
          savingsEl.hidden = false;
        } else {
          savingsEl.innerHTML = '';
          savingsEl.hidden = true;
        }
      }
    },

    /* ----- Add-ons -----
       Les cartes sont rendues côté serveur (variantes résolues par handle). Ici on ne fait
       que refléter l'état du panier : afficher les add-ons dès qu'une figurine principale y
       est, marquer ceux déjà ajoutés, et mémoriser la clé de ligne pour pouvoir les retirer. */

    addonVariantIds: function (wrap) {
      var ids = [];
      wrap.querySelectorAll('[data-addon-card]').forEach(function (c) {
        var v = parseInt(c.getAttribute('data-addon-variant'), 10);
        if (v) ids.push(v);
      });
      return ids;
    },

    updateAddons: function (cart) {
      var wrap = this.el.querySelector('[data-cart-addons]');
      if (!wrap) return;

      var addonVids = this.addonVariantIds(wrap);
      var items = cart.items || [];
      // Une figurine principale = au moins une ligne qui n'est pas un add-on.
      var hasMain = items.some(function (it) { return addonVids.indexOf(it.variant_id) === -1; });

      wrap.hidden = !hasMain;
      if (!hasMain) return;

      wrap.querySelectorAll('[data-addon-card]').forEach(function (card) {
        var vid = parseInt(card.getAttribute('data-addon-variant'), 10);
        var line = null;
        for (var i = 0; i < items.length; i++) {
          if (items[i].variant_id === vid) { line = items[i]; break; }
        }
        var added = !!line;
        card.classList.toggle('is-added', added);
        var addEl = card.querySelector('[data-addon-add]');
        var addedEl = card.querySelector('[data-addon-added]');
        if (addEl) addEl.hidden = added;
        if (addedEl) addedEl.hidden = !added;
        if (added) card.setAttribute('data-line-key', line.key);
        else card.removeAttribute('data-line-key');

        var btn = card.querySelector('[data-addon-toggle]');
        if (btn) btn.classList.remove('is-busy');
      });
    },

    toggleAddon: function (card) {
      var btn = card.querySelector('[data-addon-toggle]');
      if (btn && btn.classList.contains('is-busy')) return;

      // Déjà au panier → on retire.
      if (card.classList.contains('is-added')) {
        var key = card.getAttribute('data-line-key');
        if (key) { if (btn) btn.classList.add('is-busy'); this.removeAddonByKey(key); }
        return;
      }

      // Carte avec gravure (socle) : on ouvre le champ, l'ajout se fait à la confirmation.
      var engrave = card.querySelector('[data-engrave-form]');
      if (engrave) {
        engrave.hidden = false;
        var input = engrave.querySelector('[data-engrave-input]');
        if (input) setTimeout(function () { input.focus(); }, 50);
        return;
      }

      var vid = parseInt(card.getAttribute('data-addon-variant'), 10);
      if (btn) btn.classList.add('is-busy');
      this.addAddon(vid, null);
    },

    confirmEngrave: function (card) {
      var self = this;
      var input = card.querySelector('[data-engrave-input]');
      var text = (input && input.value ? input.value : '').trim();
      if (!text) { if (input) input.focus(); return; }
      var confirmBtn = card.querySelector('[data-engrave-confirm]');
      if (confirmBtn) confirmBtn.disabled = true;
      var vid = parseInt(card.getAttribute('data-addon-variant'), 10);
      this.addAddon(vid, { Inscription: text }, function (ok) {
        if (confirmBtn) confirmBtn.disabled = false;
        if (ok) self.closeEngrave(card);
      });
    },

    closeEngrave: function (card) {
      var form = card.querySelector('[data-engrave-form]');
      if (!form) return;
      form.hidden = true;
      var input = form.querySelector('[data-engrave-input]');
      if (input) input.value = '';
    },

    addAddon: function (variantId, properties, done) {
      var self = this;
      var fd = new FormData();
      fd.append('id', String(variantId));
      fd.append('quantity', '1');
      if (properties) {
        Object.keys(properties).forEach(function (k) { fd.append('properties[' + k + ']', properties[k]); });
      }
      fetch(routes.cart_add_url + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () { self.refresh(); if (done) done(true); })
        .catch(function () {
          // Ajout échoué : on relit le panier pour remettre les boutons dans le bon état.
          self.refresh();
          if (done) done(false);
        });
    },

    removeAddonByKey: function (key) {
      var self = this;
      self.el.classList.add('is-loading');
      fetch(routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () { self.fallback(); });
    }
  };

  /* Demande une vignette au CDN Shopify via ?width=.
     Plus robuste que de bricoler `_160x` dans le nom de fichier par regex : ici la query
     string (?v=...) ne gêne pas, et un point dans le nom de fichier ne casse rien. */
  function thumbUrl(url, width) {
    var w = width || 160;
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', String(w * (window.devicePixelRatio > 1 ? 2 : 1)));
      return u.href;
    } catch (e) {
      return url;
    }
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }
  function escapeAttr(s) {
    return String(s).replace(/"/g, '&quot;');
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  window.theme.updateCartCount = updateCartCount;
  window.theme.openCart = function () { CartDrawer.open(); };
  window.theme.openCartAdding = function (msg) { CartDrawer.openAdding(msg); };
  window.theme.refreshCart = function () { CartDrawer.refresh(); };

  /* L'ajout au panier est géré par product-form.js (POST AJAX vers /cart/add.js, photo comprise),
     qui appelle window.theme.openCart() pour ouvrir le tiroir après l'ajout. Le tiroir se
     réhydrate alors via /cart.js (render → updateAddons). Repli POST natif si l'AJAX échoue. */

  /* ---------- Mobile nav ---------- */

  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    if (!toggle || !nav) return;

    var isOpen = false;

    function setOpen(open) {
      if (open === isOpen) return;
      isOpen = open;

      toggle.setAttribute('aria-expanded', String(open));
      nav.toggleAttribute('open', open);

      if (open) {
        ScrollLock.lock();
        var close = nav.querySelector('[data-nav-close]');
        if (close) close.focus();
      } else {
        ScrollLock.unlock();
      }
    }

    toggle.addEventListener('click', function () { setOpen(!isOpen); });

    // La croix vit DANS l'overlay : le header est masqué dessous quand le menu est ouvert.
    nav.addEventListener('click', function (e) {
      if (e.target.closest('[data-nav-close]')) {
        setOpen(false);
        toggle.focus();
        return;
      }
      if (e.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { setOpen(false); toggle.focus(); }
      if (e.key === 'Tab') { trapFocus(nav, e); }
    });

    // Repasse en desktop pendant que le menu est ouvert : on referme, sinon le
    // verrou de scroll resterait actif alors que l'overlay a disparu.
    var mq = window.matchMedia('(min-width: 900px)');
    var onChange = function () { if (mq.matches) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
  }

  /* ---------- Sticky header ---------- */

  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 8);
      last = y;
    }, { passive: true });
  }

  /* ---------- Accordions ---------- */

  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (group) {
      group.addEventListener('toggle', function (e) {
        var d = e.target;
        if (d.tagName !== 'DETAILS' || !d.open) return;
        if (group.getAttribute('data-accordion') !== 'single') return;
        group.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== d) other.open = false;
        });
      }, true);
    });
  }

  /* ---------- Before/after slider ---------- */

  function initCompare() {
    document.querySelectorAll('[data-compare]').forEach(function (el) {
      var range = el.querySelector('[data-compare-range]');
      if (!range) return;
      function apply() { el.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', apply);
      apply();
    });
  }

  /* ---------- Boot ---------- */

  function init() {
    initReveal();
    CartDrawer.init();
    initNav();
    initStickyHeader();
    initAccordions();
    initCompare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
